"use client";
import Image from "next/image";

import React, { useState } from "react";

import {
    motion,
    useTransform,
    AnimatePresence,
    useMotionValue,
    useSpring,
} from "framer-motion";

export const TestimonialTooltip = () => {
    const [hoveredIndex, setHoveredIndex] = useState(null);

    const springConfig = { stiffness: 100, damping: 5 };

    const x = useMotionValue(0); // going to set this value on mouse move

    // rotate the tooltip
    const rotate = useSpring(
        useTransform(x, [-100, 100], [-45, 45]),
        springConfig,
    );

    // translate the tooltip
    const translateX = useSpring(
        useTransform(x, [-100, 100], [-50, 50]),
        springConfig,
    );

    const handleMouseMove = (event) => {
        const halfWidth = event.target.offsetWidth / 2;
        x.set(event.nativeEvent.offsetX - halfWidth); // set the x value, which is then used in transform and rotate
    };

    const people = [
        {
            id: 1,
            name: "Jérôme DELAUNEY",
            designation: "Il a créé CO-LAB Digital",
            image: "/images/site/people/jeromedelauney.jpg",
        },
        {
            id: 2,
            name: "Shompoth KHAN",
            designation:
                "Il travaille maintenant chez Jow comme Développeur React Native",
            image: "/images/site/people/shompoth.jpeg",
        },
        {
            id: 3,
            name: "Mansour MAHAMAT-SALLE",
            designation:
                "Il crée maintenant des projets à succès sur Product Hunt",
            image: "/images/site/people/mansour.jpg",
        },
        {
            id: 4,
            name: "Manon ECHE",
            designation: "Elle est maintenant freelance",
            image: "/images/site/people/manoneche.jpeg",
        },
        {
            id: 5,
            name: "Alliance TSHINDAYI",
            designation: "Il est maintenant chez Freshpay",
            image: "/images/site/people/alliance.jpeg",
        },
    ];

    return (
        <div className="flex flex-row items-center justify-center w-full">
            {people.map((testimonial, idx) => (
                <div
                    className="-mr-4 relative group"
                    key={testimonial.name}
                    onMouseEnter={() => setHoveredIndex(testimonial.id)}
                    onMouseLeave={() => setHoveredIndex(null)}
                >
                    <AnimatePresence mode="wait">
                        {hoveredIndex === testimonial.id && (
                            <motion.div
                                initial={{ opacity: 0, y: 20, scale: 0.6 }}
                                animate={{
                                    opacity: 1,
                                    y: 0,
                                    scale: 1,
                                    transition: {
                                        type: "spring",
                                        stiffness: 260,
                                        damping: 10,
                                    },
                                }}
                                exit={{ opacity: 0, y: 20, scale: 0.6 }}
                                style={{
                                    translateX: translateX,
                                    rotate: rotate,
                                    whiteSpace: "nowrap",
                                }}
                                className="absolute -top-16 -left-1/2 translate-x-1/2 flex text-xs  flex-col items-center justify-center rounded-md bg-black z-50 shadow-xl px-4 py-2"
                            >
                                <div className="absolute inset-x-10 z-30 w-[20%] -bottom-px bg-gradient-to-r from-transparent via-emerald-500 to-transparent h-px " />
                                <div className="absolute left-10 w-[40%] z-30 -bottom-px bg-gradient-to-r from-transparent via-sky-500 to-transparent h-px " />
                                <div className="font-bold text-white relative z-30 text-base">
                                    {testimonial.name}
                                </div>
                                <div className="text-white text-xs">
                                    {testimonial.designation}
                                </div>
                            </motion.div>
                        )}
                    </AnimatePresence>
                    <Image
                        onMouseMove={handleMouseMove}
                        height={50}
                        width={50}
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="object-cover !m-0 !p-0 object-top rounded-full lg:h-14 h-10 lg:w-14 w-10 border-2 group-hover:scale-105 group-hover:z-30 border-white  relative transition duration-500"
                    />
                </div>
            ))}
            <div className="pl-5 font-merriweather text-sm italic font-light">
                +7 000 développeurs
            </div>
        </div>
    );
};
